import { createContext, useContext } from 'react';

export const DrawerContext = createContext(null);

export const DrawerProvider = DrawerContext.Provider;

export const useDrawerContext = () => useContext(DrawerContext);
